import React, { Component } from "react"
import {
  Card,
  CardContent,
  Divider,
  Typography,
  Icon,
  Tooltip,
} from "@material-ui/core"
import { connect } from "react-redux"
import SearchCrewList from "../SearchCrewList/index"
import { searchShootsCrew } from "../../actions/shoots"

class SelectCrew extends Component {
  state = {
    searchCrew: [],
    loadingCrew: true,
  }
  componentDidMount() {
    const {
      role,
      location: { lat, lon },
    } = this.props

    const search = {
      roles: {
        name: role.name,
      },
      locations: {
        lat,
        lon,
      },
    }

    this.props
      .dispatch(searchShootsCrew(search, role.shoot_id))
      .then(res => {
        this.setState({ searchCrew: res })
      })
      .catch(err => {
        this.setState({ searchCrew: [] })
      })
      .finally(() => this.setState({ loadingCrew: false }))
  }

  removeRoleFromShoot = e => {
    this.props.removeRole(e)
  }

  render() {
    const { props } = this

    const { role, users, selectUser } = props

    const { searchCrew, loadingCrew } = this.state
    return (
      <Card
        style={{
          width: "300px",
          marginRight: "16px",
          marginLeft: "7px",
          marginTop: "14px",
          marginBottom: "16px",
          maxHeight: "50px",
          minHeight: "350px",
        }}
      >
        <CardContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" style={{ fontFamily: "oswald" }}>
              {role.name + " - "}
              <span style={{ color: "grey" }}>${role.crew_rate}</span>
            </Typography>
            <Tooltip title="Remove position from shoot" placement="top">
              <Icon
                onClick={this.removeRoleFromShoot}
                style={{ cursor: "pointer" }}
              >
                close
              </Icon>
            </Tooltip>
          </div>
        </CardContent>
        <Divider />
        <CardContent style={{ textAlign: "left" }}>
          {/* <Typography variant="caption">Select Crew</Typography> */}
          <SearchCrewList
            users={users}
            searchCrew={searchCrew}
            selectUser={selectUser}
            autoCompleteProps={{
              placeholder: "Search Crew",
              labelKey: "full_name",
            }}
            showSpinner={loadingCrew}
            prop={props}
          />
        </CardContent>
      </Card>
    )
  }
}

const mapStateToProps = state => {
  return {
    users: state.misc.users,
  }
}

const connector = connect(mapStateToProps)

export default connector(SelectCrew)
